import React from "react";
import { Helmet } from "react-helmet";
import "./Gallery.css";
import Navigation from "../../components/Navigation";
import GalleryCarousel from "../../components/GalleryCarousel.js";
import { events, imageIds } from "../../data/imageData";
import ImageGrid from "../../components/ImageGrid.js";

export default function Gallery() {
  return (
    <div
      className="Gallery"
      id="gallery-container"
    >
      <Helmet>
        <title>
          Gallery - Explore our Stunning Event Venue Rental Space at Sixth &
          Main Event Center
        </title>

        {/* SEO description */}
        <meta
          name="description"
          content="Explore our venue gallery showcasing events hosted at Sixth & Main Event Center, where each all-inclusive package features beautiful décor, seating, linens, and more."
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Gallery - Explore our Stunning Event Venue Rental Space at Sixth & Main Event Center"
        />
        <meta
          property="og:description"
          content="Explore our venue gallery showcasing events hosted at Sixth & Main Event Center, where each all-inclusive package features beautiful décor, seating, linens, and more."
        />
        <meta
          property="og:image"
          content="https://sixthandmaineventcenter.com/sixthandmaineventcenter.png"
        />
        <meta
          property="og:url"
          content="https://sixthandmaineventcenter.com/gallery"
        />
        <meta
          property="og:type"
          content="website"
        />

        {/* Twitter Card */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />
        <meta
          name="twitter:title"
          content="Gallery - Explore our Stunning Event Venue Rental Space at Sixth & Main Event Center"
        />
        <meta
          name="twitter:description"
          content="Browse through our gallery to see the beauty of events, from baby showers to graduation parties to company parties and more, hosted at Sixth & Main Event Center. Get inspired for your next occasion."
        />
        <meta
          name="twitter:image"
          content="https://sixthandmaineventcenter.com/sixthandmaineventcenter.png"
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://sixthandmaineventcenter.com/gallery"
        />

        {/* JSON-LD structured data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "CollectionPage",
              "name": "Gallery - Sixth & Main Event Center",
              "url": "https://sixthandmaineventcenter.com/gallery",
              "about": {
                "@type": "EventVenue",
                "name": "Sixth & Main Event Center",
                "url": "https://sixthandmaineventcenter.com",
                "image": [
                  "https://sixthandmaineventcenter.com/seeinside.jpg",
                  "https://sixthandmaineventcenter.com/sixthandmainvenueinterior.jpg",
                  "https://sixthandmaineventcenter.com/sixthandmainvenueinterior2.jpg",
                  "https://sixthandmaineventcenter.com/sixthandmainvenueinterior3.jpg",
                  "https://sixthandmaineventcenter.com/sixthandmainvenueinterior4.jpg"
                ]
              }
            }
          `}
        </script>
      </Helmet>
      <div className="hero">
        <Navigation />
        <div>
          <h1 className="text-white px-3 px-sm-5 mx-sm-5">
            Explore our stunning venue rental space
          </h1>
        </div>
      </div>
      <div
        name="gallery"
        className="Gallery container mb-5"
        id="content-wrap"
      >
        <h3
          className="mt-sm-5 mb-3 py-4 text-center text-dark fs-1 fw-medium"
          id="heading"
        >
          Venue Interior
        </h3>
        <GalleryCarousel />
      </div>
      <div
        className="gallery-summary d-block m-auto px-md-5 px-2 py-5 text-center"
        id="gallery-summary-container"
      >
        <p className="mb-4 mx-2 fs-5 fw-light">
          Enjoy a bright, elegant event space with high ceilings, natural light,
          and decorating options that make planning easier.
        </p>
        <p className="mb-4 mx-2 fs-5 fw-bold">
          Choose your package, bring your food and beverages, and walk into a
          space that’s ready for your event.
        </p>
        <div class="d-grid gap-2 mx-auto">
          <a
            href="/reservation"
            className="btn btn-primary text-uppercase mb-4 py-md-3 fw-medium"
            role="button"
          >
            See Pricing & Reserve Your Date
          </a>
        </div>

        <iframe
          className="rounded img-fluid d-block m-auto"
          src="https://www.youtube.com/embed/6YAl0zQG7Mc?si=ocSwiPdD1ZfXHruO"
          title="YouTube video player"
          alt="Video tour inside Robstown, Texas venue, Sixth & Main Event Center"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen="true"
        ></iframe>

        <p className="mt-4 fs-5 fw-light">
          The venue layout allows for flexible seating arrangements.
        </p>
        <p className="mt-4 fs-5 fw-light">
          Most clients prefer packages that include our decorating service, and
          with a variety of table cover and runner colors available, Sixth &
          Main offers a near one-stop-shop experience so you can skip the stress
          and focus on your guests.
        </p>
        <p className="mb-4 mx-2 fs-5 fw-bold">
          📸 View our gallery of past event décor below.
        </p>
      </div>

      <div className="container past-events pb-4">
        <h2 className="text-center mt-4 text-dark">Past Events</h2>
        <h3 className="text-center mb-4 text-dark">
          Sixth & Main Event Center
        </h3>
        {imageIds.map((group, index) => (
          <ImageGrid
            key={index}
            imageIds={group}
            event={events[index]}
          />
        ))}
      </div>

      {/* <section
        className="Gallery container mw-100 my-5"
        id="past-events"
      >
        <EventsGrid />
      </section> */}

      <div className="row mt-5 pb-5 w-75 m-auto">
        <div className="col-12 col-lg-6 mb-2">
          <a
            href="/tour"
            className="btn btn-primary text-uppercase"
            role="button"
          >
            Schedule Tour
          </a>
        </div>
        <div className="col-12 col-lg-6">
          <a
            href="/reservation"
            className="btn btn-primary text-uppercase"
            role="button"
          >
            Schedule Reservation
          </a>
        </div>
      </div>
    </div>
  );
}
